module.exports = __webpack_public_path__ + "static/img/pico49.cc70130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico49.png
// module id = kzIR
// module chunks = 0